<template>
  <h2 class="page-sub-header">Construction Code AI Assistant - Privacy Policy</h2>
  <p class="last-updated"><strong>Last Updated:</strong> April 9, 2025</p>

  <h2>Our Privacy Commitment</h2>
  <p>At Construction Code AI Assistant, we believe in transparency. We collect minimal data and use it only to improve
    your experience.</p>

  <h2>Information We Collect</h2>
  <ul>
    <li><strong>Email Address</strong>: The only personal information we require to create your account.</li>
    <li><strong>App Analytics</strong>: We use Firebase Analytics to understand which features are popular and how the
      app is being used.
    </li>
    <li><strong>Crash Reports</strong>: Firebase Crash Reporting helps us identify and fix technical issues.</li>
  </ul>

  <h2>How We Use Your Information</h2>
  <p>We use your information <strong>only</strong> for:</p>
  <ul>
    <li>Account authentication</li>
    <li>Improving app functionality based on usage patterns</li>
    <li>Fixing crashes and technical issues</li>
  </ul>

  <h2>What We Don't Do With Your Data</h2>
  <ul>
    <li>We <strong>do not</strong> sell, rent, or monetize your personal information in any way</li>
    <li>We <strong>do not</strong> share your information with third parties for marketing purposes</li>
    <li>We <strong>do not</strong> track your activity outside our app</li>
  </ul>

  <h2>Data Security</h2>
  <p>Your email address is securely stored using AWS Cognito, an industry-standard authentication service.</p>

  <h2>Third-Party Services</h2>
  <ul>
    <li><strong>Apple App Store</strong>: Handles all payment processing for subscriptions. We never see or store your
      payment information.
    </li>
    <li><strong>Firebase</strong>: Provides analytics and crash reporting tools. Data is anonymized and used solely for
      app improvement.
    </li>
  </ul>

  <h2>Your Rights</h2>
  <p>You can request deletion of your account and associated data by contacting us at <strong>mobapps@unemployeddeadbeats.com</strong>.
  </p>

  <h2>Policy Updates</h2>
  <p>If we make significant changes to this policy, we'll notify you through the app.</p>

  <p class="thank-you">Thank you for using Construction Code AI Assistant!</p>
</template>

<script>
export default {
  name: "CodeAuthorityPrivacy",
};
</script>